import { kategoriaObszaru } from "../przeglady/kategorieObszarow";

/**
 * [ui1006, paczka PROC, projekt 4.3 „Czego brakuje”] MACIERZ OBSZARY × SPÓŁKI — czyste funkcje odczytu odpowiedzi
 * `GET /polityki/obszary/macierz` (były w `MacierzBrakow.js`; układ z zakładkami „tabs” i akordeonem „Szczegóły obszarów”
 * pożegnany — F193; treść rysuje miejsce `pages/polityki/obszary/CzegoBrakuje.js`).
 *
 * WSZYSTKO LICZY SERWER (ta sama bramka co lista procedur): stan komórki, liczba dokumentów i tytuły — WYŁĄCZNIE dokumentów,
 * które oglądający ma prawo widzieć. Komórka bez prawa pokazuje sam stan, bez tytułu i bez przycisku.
 */
export const STANY_KOMORKI = Object.freeze({
    obowiazuje: { etykieta: "obowiązuje", ton: "ok", pojecie: "publikacja" },
    w_przygotowaniu: { etykieta: "w przygotowaniu", ton: "info", pojecie: "etap" },
    po_terminie: { etykieta: "po terminie", ton: "blad", pojecie: "przegląd treści" },
    brak: { etykieta: "brak", ton: "szary", pojecie: "obszar" },
});

/** Kod stanu komórki z odpowiedzi serwera (przyjmuje też warianty nazw — atrapy i starsze odpowiedzi). */
export const stanKomorki = (stan) => {
    const t = String(stan || "").toLowerCase();
    if (t === "obowiazuje" || t === "obowiązuje") return "obowiazuje";
    if (t.includes("termin")) return "po_terminie";
    if (t.includes("przygot") || t.includes("robocz") || t.includes("zatwierdz")) return "w_przygotowaniu";
    return "brak";
};

const liczba = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);

const komorkaZSerwera = (k = {}) => ({
    stan: stanKomorki(k.stan),
    liczba: liczba(k.liczba ?? k.liczbaDokumentow ?? k.dokumentow),
    dokumenty: (Array.isArray(k.dokumenty) ? k.dokumenty : Array.isArray(k.widoczne) ? k.widoczne : [])
        .map((d) => ({ id: d.id ?? d.documentId, tytul: d.tytul ?? d.title ?? "", etap: d.etap ?? null }))
        .filter((d) => d.id != null),
    niewidocznych: liczba(k.liczbaNiewidocznych),
    wzorKod: k.proponowanyWzorKod ?? k.wzorKod ?? null,
    wzorTytul: k.proponowanyWzorTytul ?? null,
});

/** Odpowiedź GET obszary/macierz → { spolki: [{id, nazwa, objetaUstawa}], obszary: [{kod, nazwa, grupa, komorki: Map(companyId → komórka)}] }. */
export const normalizujMacierz = (data) => {
    const d = data || {};
    const spolki = (d.spolki || d.kolumny || []).map((c) => {
        const id = Number(c.companyId ?? c.id);
        return { id, nazwa: c.nazwa ?? c.name ?? c.companyNazwa ?? `Spółka nr ${id}`, objetaUstawa: typeof c.objetaUstawa === "boolean" ? c.objetaUstawa : null };
    }).filter((c) => Number.isFinite(c.id));
    const obszary = (d.obszary || d.wiersze || []).map((o) => {
        const zrodlo = o.komorki || o.spolki || [];
        const komorki = new Map();
        if (Array.isArray(zrodlo)) zrodlo.forEach((k) => komorki.set(Number(k.companyId ?? k.spolkaId ?? k.id), komorkaZSerwera(k)));
        else Object.entries(zrodlo).forEach(([id, k]) => komorki.set(Number(id), komorkaZSerwera(k)));
        const grupa = String(o.grupa ?? o.zrodlo ?? "").toLowerCase();
        return {
            kod: o.kod ?? o.obszarKod ?? "",
            nazwa: o.nazwa ?? o.obszarNazwa ?? o.kod ?? "",
            grupa: kategoriaObszaru(grupa === "wlasne" || grupa === "własne" ? "wlasny" : grupa),
            komorki,
        };
    });
    return { spolki, obszary };
};

/** Żeton widoku „Czego brakuje” → grupa obszarów w odpowiedzi macierzy. */
export const GRUPA_WIDOKU = Object.freeze({ ustawa: "nis2", normy: "iso", wlasne: "wlasny" });

/** Czy wiersz obszaru ma brak w którejkolwiek spółce. */
export const obszarZBrakiem = (obszar, spolki) => (spolki || []).some((c) => ((obszar.komorki.get(c.id) || {}).stan || "brak") === "brak");

/** Kafel spółki Wykazu KSC bez stanu zgłoszonego — TA SAMA reguła co `bezStanuZgloszonego` na pulpicie Wykazu (`components/WykazKsc/KafelSpolki.js`). */
export const kafelBezStanuZgloszonego = (kafel) => !!kafel && kafel.polZlozonych != null && (Number(kafel.polZlozonych) || 0) === 0;
